import React, { useState, useEffect } from 'react';
import contentService from '../services/contentService';
import DesarrollaModal from './DesarrollaModal';
import Loading from './Loading';
import './DesarrollaList.css';

const DesarrollaList = () => {
  const [desarrollaList, setDesarrollaList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedDesarrolla, setSelectedDesarrolla] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    loadDesarrolla();
  }, []);

  const loadDesarrolla = async () => {
    setLoading(true);
    try {
      const response = await contentService.getDesarrolla();
      console.log('📋 Respuesta completa:', response);
      console.log('📋 Desarrolla data:', response.data);

      // Verificar si response.data es un array o está dentro de results
      const desarrollaData = Array.isArray(response.data)
        ? response.data
        : (response.data?.results || []);

      console.log('📋 Lista final de desarrolla:', desarrollaData);
      setDesarrollaList(desarrollaData);
    } catch (error) {
      console.error('Error loading desarrolla:', error);
      alert('Error al cargar desarrolla');
      setDesarrollaList([]); // Asegurar que siempre sea array
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setSelectedDesarrolla(null);
    setShowModal(true);
  };

  const handleEdit = (desarrolla) => {
    setSelectedDesarrolla(desarrolla);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Estás seguro de eliminar este tipo de desarrollo?')) return;

    try {
      await contentService.deleteDesarrolla(id);
      alert('✅ Desarrolla eliminado');
      loadDesarrolla();
    } catch (error) {
      console.error('Error deleting desarrolla:', error);
      alert('Error al eliminar desarrolla');
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedDesarrolla(null);
    loadDesarrolla();
  };

  const filteredDesarrolla = desarrollaList.filter(item =>
    item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.description?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Función para obtener el nombre legible
  const getDisplayName = (name) => {
    const names = {
      'interno': 'Interno',
      'externo': 'Externo',
      'agencia': 'Agencia',
      'freelance': 'Freelance',
      'influencer': 'Influencer'
    };
    return names[name] || name;
  };

  // Función para obtener el color (desde la BD o fallback)
  const getTypeColor = (item) => {
    // Usar el color de la base de datos si existe, sino usar el por defecto
    return item.color || '#6b7280';
  };

  return (
    <div className="influencer-list-container">
      {/* Header */}
      <div className="influencer-header">
        <div className="influencer-header-left">
          <h1 className="influencer-title">Desarrolladores</h1>
          <span className="influencer-count">{filteredDesarrolla.length}</span>
        </div>
        <div className="influencer-header-right">
          <input
            type="text"
            placeholder="Buscar..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="il-search-input il-search-header"
          />
          <button onClick={handleCreate} className="il-btn-primary">
            + Desarrollador
          </button>
        </div>
      </div>

      {loading ? (
        <Loading fullScreen={false} />
      ) : filteredDesarrolla.length === 0 ? (
        <div className="il-empty-state">
          <p>No se encontraron tipos de desarrollo</p>
          {searchTerm && (
            <button onClick={() => setSearchTerm('')} className="il-btn-secondary">
              Limpiar búsqueda
            </button>
          )}
        </div>
      ) : (
        <div className="il-table-container">
          <table className="il-table">
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Descripción</th>
                <th>Estado</th>
                <th>Creado</th>
                <th aria-label="Acciones"></th>
              </tr>
            </thead>
            <tbody>
              {filteredDesarrolla.map((item) => (
                <tr key={item.id}>
                  <td>
                    <span className="dv-color-dot" style={{ background: getTypeColor(item) }} />
                    <span className="il-name">{getDisplayName(item.name)}</span>
                  </td>
                  <td>{item.description || <span className="dv-muted">Sin descripción</span>}</td>
                  <td>
                    <span className={`il-status ${item.is_active ? 'active' : 'inactive'}`}>
                      {item.is_active ? '✓ Activo' : '✗ Inactivo'}
                    </span>
                  </td>
                  <td>
                    {item.created_at
                      ? new Date(item.created_at).toLocaleDateString('es-ES', { year: 'numeric', month: 'short', day: 'numeric' })
                      : '—'}
                  </td>
                  <td>
                    <div className="il-actions">
                      <button onClick={() => handleEdit(item)} className="il-btn-icon" title="Editar">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
              </svg>
                      </button>
                      <button onClick={() => handleDelete(item.id)} className="il-btn-icon danger" title="Eliminar">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
              </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <DesarrollaModal
          desarrolla={selectedDesarrolla}
          onClose={handleModalClose}
        />
      )}
    </div>
  );
};

export default DesarrollaList;